export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGoogleAnalytics = () => {
  if (!GA_MEASUREMENT_ID) return;
  if (typeof window === 'undefined') return;
  if ((window as any).gtagInitialized) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_MEASUREMENT_ID}', { send_page_view: false });
  `;
  document.head.appendChild(inlineScript);

  (window as any).gtagInitialized = true;
};

export const trackPageView = (path: string) => {
  if (!GA_MEASUREMENT_ID) return;
  if (typeof window === 'undefined') return;
  const gtag = (window as any).gtag;
  if (!gtag) return;
  gtag('event', 'page_view', {
    page_path: path,
  });
};

